import { Component } from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAttributeGroup } from 'src/app/assabil-kernel/models/entities/control-tables/product-attribute-group';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';



@Component({
    selector: 'product-attribute-group-lov',
    templateUrl: './product-attribute-group-lov.component.html',
    styleUrls: ['./product-attribute-group-lov.component.scss']
})


export class ProductAttributeGroupLovComponent extends GenericLovComponent   {

     code         : string; 
     name         : string; 

    productAttributeGroups: ProductAttributeGroup[] = [];

    columns = [
        {  prop: 'productAttributeGroupCode', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor(
    public dialogRef: MatDialogRef<ProductAttributeGroupLovComponent>,
     protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "productAttributeGroup";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.productAttributeGroups = result;
    })
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
closeModal(row : ProductAttributeGroup){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
